import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ActionLink from "./ActionLink";

class Pager extends Component {
    static propTypes = {
        pageSize: PropTypes.number.isRequired,
        pageIndex: PropTypes.number.isRequired,
        totalCount: PropTypes.number.isRequired,
        size: PropTypes.string,
        onChange: PropTypes.func
    };
    static defaultProps = {
        size: 'xs'
    };
    state = this.createState();

    componentWillReceiveProps(nextProps) {
        this.setState(this.createState(nextProps));
    }

    render() {
        const {size, className, pageIndex} = this.props;
        let startIndex = pageIndex - 2 > 0
            ? pageIndex - 2
            : 0;
        let endIndex = startIndex + 4 < this.state.pageCount
            ? startIndex + 4
            : this.state.pageCount - 1;
        let pages = [];
        for (let i = startIndex; i <= endIndex; i++)
            pages.push(i);

        return (
            <ul className={`pagination pagination-${size} ${className}`}>
                <li>
                    <ActionLink onClick={() => this.goPrev()}>«</ActionLink>
                </li>
                {pages.map(i =>
                    <li key={i} className={pageIndex === i ? 'active' : ''}>
                        <ActionLink onClick={() => this.go(i)}>{i + 1}</ActionLink>
                    </li>
                )}
                <li>
                    <ActionLink onClick={() => this.goNext()}>»</ActionLink>
                </li>
            </ul>
        );
    }

    createState(props = this.props) {
        const {pageSize, totalCount} = props;
        return {
            pageSize,
            pageCount: Math.ceil(totalCount / pageSize) || 1
        };
    }

    goPrev() {
        const {onChange} = this.props;
        if (onChange && this.props.pageIndex > 0)
            onChange(this.props.pageIndex - 1);
    }

    goNext() {
        const {onChange} = this.props;
        if (onChange && this.props.pageIndex < this.state.pageCount - 1)
            onChange(this.props.pageIndex + 1);
    }

    go(pageIndex) {
        const {onChange} = this.props;
        if (onChange)
            onChange(pageIndex);
    }
}

export default Pager;


// WEBPACK FOOTER //
// ./src/controls/Pager.js